import { render, staticRenderFns } from "./grupJM.vue?vue&type=template&id=2fd04853&scoped=true&"
import script from "./grupJM.vue?vue&type=script&lang=js&"
export * from "./grupJM.vue?vue&type=script&lang=js&"
import style0 from "./grupJM.vue?vue&type=style&index=0&id=2fd04853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd04853",
  null
  
)

export default component.exports